import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState"; // Store Custom Code
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo"; // Store Custom Code
import {
    getCurrentShipTosDataView,
    getCurrentShipToState,
} from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors"; // Store Custom Code
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link"; // Store Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss"; // Store Custom Code
import setPdpTabToDiscontinued from "@store/Handlers/SetPdpTabToDiscontinued"; // Store Custom Code
import { COLORS, SPACING, TYPOGRAPHY } from "@store/theme/design"; // Store Custom Code
import * as React from "react";
import { connect, ResolveThunks } from "react-redux"; // Store Custom Code
import { css } from "styled-components";

const enum fields {
    hideDiscontinuedSkus = "hideDiscontinuedSkus", // Store Custom Code
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.hideDiscontinuedSkus]: boolean; // Store Custom Code
    };
}

// Store Custom Code
const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state).value,
    currentShipToState: getCurrentShipToState(state),
    userName: state.context.session?.userName,
    isGuest: state.context.session?.isGuest,
    session: state.context.session,
});

// Store Custom Code
const mapDispatchToProps = {
    setPdpTabToDiscontinued,
    loadCurrentShipTo,
};

// Store Custom Code
type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Store Custom Code

export interface ProductDetailsPartNumberStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyProps;
    extraSkusLabelText?: TypographyProps; // Store Custom Code
    extraSkusText?: TypographyProps; // Store Custom Code
    valueText?: TypographyProps;
    moreSkusButton?: LinkPresentationProps; // Store Custom Code
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        size: TYPOGRAPHY.size.base,
        css: css`
            color: ${COLORS.text.light};
            margin-right: 5px;
            line-height: 120%;
        `,
    },
    // Store Custom Code
    extraSkusText: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: inline-block;
                            margin-right: ${SPACING.xxsmall};
                            font-size: ${TYPOGRAPHY.size.tiny};
                            color: ${COLORS.text.light};
                        `,
                        css``,
                        css`
                            font-size: ${TYPOGRAPHY.size.smaller};
                        `,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    // Store Custom Code
    extraSkusLabelText: {
        size: TYPOGRAPHY.size.base,
        css: css`
            color: ${COLORS.text.light};
            margin-top: ${SPACING.standard};
            line-height: 120%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-right: ${SPACING.xsmall};
                            font-size: ${TYPOGRAPHY.size.tiny};
                        `,
                        css``,
                        css`
                            font-size: ${TYPOGRAPHY.size.smaller};
                        `,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    // Store Custom Code
    moreSkusButton: {
        color: COLORS.text.light,
        typographyProps: {
            size: TYPOGRAPHY.size.base,
            css: css`
                color: ${COLORS.text.light};
                margin-bottom: 0px;
                font-weight: bold;
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                    color: ${COLORS.text.light};
                }
            `,
        },
    },
    valueText: {
        size: TYPOGRAPHY.size.base,
        css: css`
            color: ${COLORS.text.light};
            margin-bottom: 0px;
            font-weight: bold;
        `,
    },
    wrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            border-bottom: 1px solid ${COLORS.border.base};
                            padding: 0 0 15px 0;
                            margin: 0 0 10px 0;
                            display: inline-block;
                            width: auto;
                        `,
                        css``,
                        css`
                            display: block;
                            border-right: none;
                            border-bottom: 1px solid ${COLORS.border.base};
                            padding-bottom: 15px;
                            padding: 0 0 25px 0;
                            margin: 15px 0;
                        `,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
};

const styles = partNumberStyles;

// Store Custom Code
const ProductDetailsPartNumber: React.FC<Props> = ({
    product,
    userName,
    isGuest,
    setPdpTabToDiscontinued,
    fields,
    loadCurrentShipTo,
    currentShipTo,
    currentShipToState,
    session,
}) => {
    if (!product.productNumber) {
        return null;
    }

    // Store Custom Code - START
    const [mainSku, setMainSku] = React.useState("");
    let extraSkus: string[] = [];
    const isAuthenticated = session && session.isAuthenticated && !session.rememberMe && !session.isGuest;

    const parseSkuList = (propertyName: string) => {
        if (!product.properties[propertyName]) {
            return [];
        }
        const ids: string = product.properties[propertyName];
        const arrayIds: string[] = ids?.split(";").filter(element => {
            return element !== "";
        });
        return arrayIds;
    };

    const handleDiscontinuedProductsClick = () => {
        setPdpTabToDiscontinued({ triggerDiscontinuedTabNeeded: true });
    };
    React.useEffect(() => {
        // User is logged in, display SKUs based on market context
        if (isAuthenticated && !currentShipToState.value && !currentShipToState.isLoading) {
            loadCurrentShipTo();
        }
    }, []);

    // Store Custom Code
    React.useEffect(() => {
        if (!userName && !isGuest) {
            // User is logged out, display all SKUs
            setMainSku(product.productNumber);
            const ExtraSkusId = "sku-NYBS-CT"; // Todo: Refactor to allow more than two markets

            if (fields.hideDiscontinuedSkus !== true) {
                extraSkus = parseSkuList(ExtraSkusId);
            }
        } else {
            const userMarket = currentShipToState.value?.properties?.customerMarket;
            if (userMarket) {
                const productNumber = product.productNumber;
                const productSkuListForMarket = parseSkuList(`sku-${userMarket}`); // Search for an array of SKUs corresponding to market
                if (productSkuListForMarket) {
                    // SKUs list was found
                    setMainSku(productSkuListForMarket[0] ? productSkuListForMarket[0] : productNumber); // First of the list is our main SKU
                    if (productSkuListForMarket.length > 1) {
                        extraSkus = productSkuListForMarket.filter(e => e !== mainSku); // Filter main SKU from list
                    }
                } else {
                    // No SKU list for market: display productNumber
                    setMainSku(product.productNumber);
                }
            } else {
                setMainSku(product.productNumber);
            }
        }
    }, [currentShipTo]);
    // Store Custom Code - END
    // Store Custom Code - Show discontinued skus and add a button to open the tab
    const replacementProductSkus: string[] = product?.properties?.replacedProductErpNumbers
        ?.split(";")
        .filter(element => {
            return element !== "";
        });
    let firstSku = null;
    let isMultipleReplacements = false;
    if (replacementProductSkus) {
        firstSku = replacementProductSkus[0];
        isMultipleReplacements = replacementProductSkus.length > 1;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsPartNumber">
                <Typography {...styles.labelText}>{translate("SKU")}</Typography>
                {mainSku}
                {!fields.hideDiscontinuedSkus &&
                    firstSku &&
                    (isMultipleReplacements ? (
                        <>
                            {" "}
                            {translate("replaces {0}", firstSku)}{" "}
                            <Link {...styles.moreSkusButton} onClick={handleDiscontinuedProductsClick}>
                                {translate("and others")}
                            </Link>
                        </>
                    ) : (
                        <> {translate("replaces {0}", firstSku)}</>
                    ))}
            </Typography>
            {/* Store Custom Code */}
            {extraSkus && extraSkus.length > 0 && (
                <>
                    <Typography {...styles.extraSkusLabelText}>{translate("Extra SKUs")}</Typography>
                    {extraSkus.map((sku, index) => (
                        <Typography {...styles.extraSkusText} key={sku}>
                            {sku}
                        </Typography>
                    ))}
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsPartNumber)), // Store Custom Code
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.hideDiscontinuedSkus,
                editorTemplate: "CheckboxField",
                tooltip: "Hide list of extra skus and button",
                defaultValue: false,
                tab: {
                    displayName: "Basic",
                    sortOrder: 0,
                },
            },
        ],
    },
};

export default widgetModule;
